import { render, staticRenderFns } from "./vPuesto.vue?vue&type=template&id=c144ab9e&"
import script from "./vPuesto.vue?vue&type=script&lang=js&"
export * from "./vPuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports